<div class="container-fluid" style="padding: 0 1.8rem 1.8rem">
    <mat-card style="padding: 0px;">
        <mat-card-header style="background-color:red; ">
            <b style="text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);color: #FFFFFF;float: center;">Gateway Data</b>
        </mat-card-header>
        <mat-card-content style="overflow: auto;scroll-behavior: smooth;padding-right: 3px;padding-left: 3px;padding-bottom: 3px;">

              <ng-container  >
<div >
    <table mat-table matTableExporter [dataSource]="dataSource" style="height: 550px;  border-collapse: collapse;"  #exporter="matTableExporter" matSort class="example-container mat-elevation-z8" >
    <div  *ngFor="let col of tableheading">
      <ng-container   [matColumnDef]="col">
        <div style=" position: sticky; /* Make the table heading sticky */
        top: 0; /* Stick the heading to the top of the container */
        z-index: 1;" *ngIf="col">
            <th mat-header-cell *matHeaderCellDef mat-sort-header style=" background-color:wheat; color: black;"> {{col}} </th>
        </div>
          <div style="overflow-y: auto;  overflow-x: hidden;" *ngIf="col">
              <td  class="scrolling-text" mat-cell *matCellDef="let element" > {{element[col]}} </td>
          </div>

        </ng-container>
      </div>
        <tr mat-header-row *matHeaderRowDef="tableheading"></tr>
        <tr mat-row *matRowDef="let row; columns: tableheading;"></tr>
   </table>
  </div>
  </ng-container>
  </mat-card-content>
  </mat-card>
  </div>